<template>
  <v-main>
    <v-container>
      <v-card
        max-width="600"
        class="mx-auto mt-12"
        :class="$vuetify.breakpoint.smAndUp ? 'pa-10' : 'pa-4'"
      >
        <v-row align="center" no-gutters>
          <logo class="ml-4 mt-2"/> <p class="mb-0 mt-2 ml-2 helmi-navigation__title">
            HELMI
          </p><p
            class="mb-0 mt-2 helmi-navigation__title"
            :class="$vuetify.breakpoint.xs ? 'smaller ml-4' : 'ml-2'"
          >
            <template v-if="$vuetify.breakpoint.smAndUp">
              -
            </template>Allekirjoitusten aitoustarkistus
          </p>
        </v-row>
        <v-card-text class="pb-0">
          <v-alert
            type="error"
            text
            class="mt-4"
          >
            <b>Linkki on virheellinen tai vanhentunut</b><br>
            Pyydä uusi linkki!
          </v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
export default {
  name: 'FileVerificationExpired',
  components: {
    logo: () => import('@/components/Icon'),
  },
};
</script>
<style scoped lang="scss">
* {
  font-family: 'Quicksand', sans-serif;
}

.smaller {
  font-size: 16px;
}
</style>
